/**
 * Remove duplicates from an array of topics
 *
 * In case of duplicate the "old" value (on the left of the array)
 * gets replaced by the "new" value (on the right of the array)
 */
const removeDuplicateTopics = (topics) => {
  const results = topics.reduce(
    ({ ids, items }, item) => ({
      ids: items[item.id] ? ids : ids.concat(item.id),
      items: { ...items, [item.id]: item },
    }),
    { ids: [], items: {} },
  );

  return results.ids.map((id) => results.items[id]);
};

export default removeDuplicateTopics;
